<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title class="headline modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="open=false"><v-icon large>fal fa-times</v-icon></button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding">
				<div style="color: #666; font-size: 0.9em;">
					<h2 class="mb-4" style="font-size: 2.0em;">Why do I have to login with LinkedIn?</h2>
					<p>WRKPRTY is a platform that enables home-based and remote workers to host or attend a social co-working event (a “work party”) any place, any time – frequently in private homes.</p>
					<p>Registering with your Linkedin account helps us ensure all members are REAL people, with professional interests. It is for the protection of our hosts, as well as member-guests, like yourself.</p>
					<p>Thank you for understanding and your interest in joining WRKPRTY. We look forward to meeting you!</p>
					<p>If you’re having trouble logging in or have a question, please <a @click="setModalOpen({prop:'contactForm', value: true})">contact us!</a></p>
					<!-- <p>Email us hello@wrkprty.com to get setup with an account if you do not have LinkedIn</p> -->
					<p>Thanks again!</p>
					<p>Aidan Makepeace<br>Founder @ wrkprty</p>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'WhyLinkedinModal',
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters(['getModalProp']),
		open: {
			get() {
				return this.getModalProp('whyLinkedinModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'whyLinkedinModal', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
